import React, { useEffect } from 'react'
import './style.css'
import { useLocation } from 'react-router-dom';

export default function Quiz() {
  const location = useLocation()

  useEffect(()=>{
    if(document.fullscreenEnabled){
      document.documentElement?.requestFullscreen()
      .then(() => {
        console.log("ok");
      })
      .catch((error) =>{

      });
    }
  },[location.pathname])

  return (
    <div className='Quiz_Game'>
      <div className='Quiz_Game_Quest_Wrap'>
        <div className='Quiz_Game_Quest_Con'>
          <h2>What is the national bird of India?</h2>
        </div>
        <div className='Quiz_Game_Quest_Con1'>
          ?
        </div>
      </div>
      <div className='Quiz_Game_Ans_Con'>
        <div className='Quiz_Game_Ans_Wrap'>
          <div className='Quiz_Game_Ans'>
            <h3>Parrot</h3>
          </div>
          <div className='Quiz_Game_Ans1'>
            A
          </div>
        </div>
        <div className='Quiz_Game_Ans_Wrap'>
          <div className='Quiz_Game_Ans'>
            <h3>Duck</h3>
          </div>
          <div className='Quiz_Game_Ans1'>
            B
          </div>
        </div>
        <div className='Quiz_Game_Ans_Wrap'>
          <div className='Quiz_Game_Ans'>
            <h3>Peacock</h3>
          </div>
          <div className='Quiz_Game_Ans1'>
            C
          </div>
        </div>
      </div>
    </div>
  )
}
